export default {
  routerObj: {
    path: '/tenant',
    component: () => import('@/views/routerView.vue'),
    name: '租户',
    children: [
      {
        path: '/tenant/tenantManage',
        component: () => import('@/views/tenant/tenantManage/index.vue'),
        name: '租户管理',
        props: true
      },
      {
        path: '/tenant/tenantPage',
        component: () => import('@/views/tenant/tenantPage/index.vue'),
        name: '租户配置',
        props: true
      }
    ]
  }
}
